import 'css-chunk:src/applications/TermsApp/components/BulkTerms/CollaborationDetails/CollaborationDetails.scss';export default {
  "CollaborationDetails": "_CollaborationDetails_xjb6q_1",
  "briefDetails": "_briefDetails_xjb6q_5",
  "alertText": "_alertText_xjb6q_10",
  "compensationContainer": "_compensationContainer_xjb6q_14",
  "rewardContainer": "_rewardContainer_xjb6q_19",
  "projectBudgetInfoContainer": "_projectBudgetInfoContainer_xjb6q_22"
};